var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.inputType == "Journal"
    ? _c("app-human-filter-edit-value-custom-journal", {
        attrs: { value: _vm.value, label: _vm.label, multi: _vm.multi },
        on: {
          input: function ($event) {
            return _vm.onInput($event)
          },
        },
      })
    : _vm.inputType == "SaleType"
    ? _c("app-human-filter-edit-value-custom-sale-type", {
        attrs: { value: _vm.value, label: _vm.label, multi: _vm.multi },
        on: {
          input: function ($event) {
            return _vm.onInput($event)
          },
        },
      })
    : _vm.inputType == "CrmStatus"
    ? _c("app-human-filter-edit-value-custom-crm-status", {
        attrs: { value: _vm.value, label: _vm.label, multi: _vm.multi },
        on: {
          input: function ($event) {
            return _vm.onInput($event)
          },
        },
      })
    : _vm.inputType == "BookYear"
    ? _c("app-human-filter-edit-value-custom-book-year", {
        attrs: {
          value: _vm.value,
          label: _vm.label,
          multi: _vm.multi,
          "value-index": _vm.valueIndex,
          filter: _vm.filter,
        },
        on: {
          input: function ($event) {
            return _vm.onInput($event)
          },
        },
      })
    : _vm.inputType == "Creator"
    ? _c("app-human-filter-edit-value-custom-user", {
        attrs: { value: _vm.value, label: _vm.label, multi: _vm.multi },
        on: {
          input: function ($event) {
            return _vm.onInput($event)
          },
        },
      })
    : _vm.inputType == "Contact"
    ? _c("app-human-filter-edit-value-custom-contact", {
        attrs: { value: _vm.value, label: _vm.label, multi: _vm.multi },
        on: {
          input: function ($event) {
            return _vm.onInput($event)
          },
        },
      })
    : _vm.inputType == "ContactSupplier"
    ? _c("app-human-filter-edit-value-custom-contact-supplier", {
        attrs: { value: _vm.value, label: _vm.label, multi: _vm.multi },
        on: {
          input: function ($event) {
            return _vm.onInput($event)
          },
        },
      })
    : _vm.inputType == "ContactAddress"
    ? _c("app-human-filter-edit-value-custom-contact-address", {
        attrs: { value: _vm.value, label: _vm.label, multi: _vm.multi },
        on: {
          input: function ($event) {
            return _vm.onInput($event)
          },
        },
      })
    : _vm.inputType == "Product"
    ? _c("app-human-filter-edit-value-custom-product", {
        attrs: { value: _vm.value, label: _vm.label, multi: _vm.multi },
        on: {
          input: function ($event) {
            return _vm.onInput($event)
          },
        },
      })
    : _vm.inputType == "CountryCode"
    ? _c("app-human-filter-edit-value-custom-country-code", {
        attrs: { value: _vm.value, label: _vm.label, multi: _vm.multi },
        on: {
          input: function ($event) {
            return _vm.onInput($event)
          },
        },
      })
    : _vm.inputType == "SellPriceCategory"
    ? _c("app-human-filter-edit-value-custom-sell-price-category", {
        attrs: { value: _vm.value, label: _vm.label, multi: _vm.multi },
        on: {
          input: function ($event) {
            return _vm.onInput($event)
          },
        },
      })
    : _vm.inputType == "BankKind"
    ? _c("app-human-filter-edit-value-custom-bank-kind", {
        attrs: { value: _vm.value, label: _vm.label, multi: _vm.multi },
        on: {
          input: function ($event) {
            return _vm.onInput($event)
          },
        },
      })
    : _vm.inputType == "Car"
    ? _c("app-human-filter-edit-value-custom-car", {
        attrs: { value: _vm.value, label: _vm.label, multi: _vm.multi },
        on: {
          input: function ($event) {
            return _vm.onInput($event)
          },
        },
      })
    : _vm.inputType == "VatRegime"
    ? _c("app-human-filter-edit-value-custom-vat-regime", {
        attrs: { value: _vm.value, label: _vm.label, multi: _vm.multi },
        on: {
          input: function ($event) {
            return _vm.onInput($event)
          },
        },
      })
    : _vm.inputType == "PurchaseVatRegime"
    ? _c("app-human-filter-edit-value-custom-vat-regime-purchase", {
        attrs: { value: _vm.value, label: _vm.label, multi: _vm.multi },
        on: {
          input: function ($event) {
            return _vm.onInput($event)
          },
        },
      })
    : _vm.inputType == "TaskStatus"
    ? _c("app-human-filter-edit-value-custom-task-status", {
        attrs: { value: _vm.value, label: _vm.label, multi: _vm.multi },
        on: {
          input: function ($event) {
            return _vm.onInput($event)
          },
        },
      })
    : _vm.inputType == "Sale"
    ? _c("app-human-filter-edit-value-custom-sale", {
        attrs: { value: _vm.value, label: _vm.label, multi: _vm.multi },
        on: {
          input: function ($event) {
            return _vm.onInput($event)
          },
        },
      })
    : _vm.inputType == "quarter"
    ? _c("app-human-filter-edit-value-custom-quarter", {
        attrs: { value: _vm.value, label: _vm.label, multi: _vm.multi },
        on: {
          input: function ($event) {
            return _vm.onInput($event)
          },
        },
      })
    : _vm.inputType == "month"
    ? _c("app-human-filter-edit-value-custom-month", {
        attrs: {
          value: _vm.value,
          label: _vm.label,
          multi: _vm.multi,
          filter: _vm.filter,
        },
        on: {
          input: function ($event) {
            return _vm.onInput($event)
          },
        },
      })
    : _vm.inputType == "BankType"
    ? _c("app-human-filter-edit-value-custom-bank-type", {
        attrs: { value: _vm.value, label: _vm.label, multi: _vm.multi },
        on: {
          input: function ($event) {
            return _vm.onInput($event)
          },
        },
      })
    : _vm.inputType == "Folder"
    ? _c("app-human-filter-edit-value-custom-folder", {
        attrs: { value: _vm.value, label: _vm.label, multi: _vm.multi },
        on: {
          input: function ($event) {
            return _vm.onInput($event)
          },
        },
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }